import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import BackButton from '../../../../components/UI/BackButton';
import { translate } from '../../../../utils/util';
import ListOrder from './ListOrder';

const PickingOrders = (props) => {
    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-dolly" />
                        {translate('expedition:picking.title')}
                    </div>
                    <div className="subtitle">
                        | <i className="material-icons">business_center</i>
                        {translate('expedition:picking.orders')}
                    </div>
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '40px' }}>
                <ListOrder data={props.orders} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        orders: state.pickingReducer.orders,
    };
};

const mapDispatchToProps = () => {
    return {
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PickingOrders)));
